import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class UnsupportedBrowserAlert extends PureComponent {
  static propTypes = {
    closeUnsupportedBrowserAlert: PropTypes.func.isRequired,
    isUnsupportedBrowserAlertOpen: PropTypes.bool,
  };

  closeAlert = () => {
    this.props.closeUnsupportedBrowserAlert();
  }

  render() {
    if (!this.props.isUnsupportedBrowserAlertOpen) {
      return null;
    }

    return (
      <section id="unsupportedBrowserAlert" className="browserWarnings stickToTop">
        <div className="browserWarnings__container">
          <div className="browserWarnings__content">
            <h2 className="browserWarnings__heading">
              Oh dear, it looks like your browser is out of date.
            </h2>
            <p>
              For security, you need to&nbsp;update your browser&nbsp;
              before shopping with us. Or, try shopping on our&nbsp;
              <a
                className="browserWarnings__link"
                href="/webshop/getMobileApp.do"
                target="_blank"
                rel="noopener noreferrer"
              >
                smartphone and tablet app
              </a>.
            </p>
            <button
              className="browserWarnings__remindLater"
              onClick={this.closeAlert}
              aria-label="Close"
            />
            <img className="u-hiddenVisually" src="/webshop/wa/browser/notSupported" alt="" aria-hidden="true" />
          </div>
        </div>
      </section>
    );
  }
}
